import api from "../client.ts";

const getAll = async () => {
  const { data } = await api.get("/depense/readAll");
  return data;
};


export const depenseController = {getAll}